export default __webpack_public_path__ + "static/media/house1.152ebb9a.svg";